import React from "react";
import { TimelineData } from "src/shared/types/src";
import { ACTIVITY_DETAIL_TYPE } from "src/shared/config/src";
import AccidentMedicineReportCardInternalDetails from "src/app/components/commonComponents/AccidentMedicineReportCardInternalDetails";
import BaseCard from "src/app/components/commonComponents/BaseCard";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "src/app/navigation/routes";

const AccidentSheetCard = ({ timelineItem }: { timelineItem: TimelineData }) => {
    
    const navigate = useNavigate();
    // const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);
    return (
        <BaseCard onPressFunc={() => navigate(AppRoutes.ACCIDENT_SHEET_DETAILS_SCREEN(timelineItem?.id), { state: { headerTitle: timelineItem?.content }})} clickable={true} customBaseCardStyle="mg-t-15">
            <AccidentMedicineReportCardInternalDetails
                content={timelineItem?.content}
                timestamp={timelineItem?.timestamp}
                status={timelineItem?.status}
                notes={timelineItem?.details?.notes}
                type={ACTIVITY_DETAIL_TYPE.ACCIDENT}
            />
        </BaseCard>
    )
}

export default AccidentSheetCard;